import { useEffect, useState } from "react";
import { IoInformationCircleOutline } from "react-icons/io5";
import "./toggle.css";
import { HiOutlineExternalLink } from "react-icons/hi";
import { Tooltip } from "react-tooltip";

function Toggle({ index = 0, config, left, right, setStateField, state, label = null }) {
    const [isChecked, setChecked] = useState(false);

    const handleChange = () => {
        setChecked(!isChecked);
        setStateField(config.fieldName, !isChecked);
    };

    useEffect(() => { setChecked(state) }, [state]);

    return (
        <div className={"toggle-wrapper"}>
            {label &&
                <div className={"label-container"}>
                    <p
                        onClick={() => window.open(config.docsLink)}
                        className={config.docsLink ? "label has-hyperlink" : "label"}
                    >
                        {config.fieldName}
                        {config.docsLink &&
                            <HiOutlineExternalLink className={"external-link-icon"} />
                        }
                    </p>
                    {config.tooltip &&
                        <IoInformationCircleOutline
                            data-tooltip-id={"info-tooltip"}
                            data-tooltip-place={"right"}
                            data-tooltip-content={config.tooltip}
                            onClick={config.docsLink && (() => window.open(config.docsLink))}
                        />
                    }
                </div>
            }
            {config.tooltipType = "top-bar" && config.tooltip &&
                <Tooltip id="toggle-tooltip" />
            }
            <div className="toggle"
                data-tooltip-id={"tooltip"}
                data-tooltip-place={"bottom"}
                data-tooltip-html={config.tooltip}
            >
                <input
                    type="checkbox"
                    id={"toggle " + config.fieldName + index}
                    className="toggleCheckbox"
                    onChange={handleChange}
                    checked={isChecked}
                />
                <label htmlFor={"toggle " + config.fieldName + index} className="toggleContainer">
                    <div style={isChecked ? null : { color: "white" }}>{left}</div>
                    <div style={isChecked ? { color: "white" } : null}>{right}</div>
                </label>
            </div>
        </div>
    );
}

export default Toggle;
